<template>
    <div class="mb-3 row d-flex justify-content-between">
        <div class="col col-12 col-md-9 display-4">
            <slot></slot>
        </div>
        <div class="col col-12 col-md-3 text-right">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['loading']
}
</script>